
// Returns height of a header element
export default function navbarHeight(){
 const navbar = document.querySelector('header');
 if(navbar) {
  return navbar.offsetHeight;
 } else {
  return 0;
 }
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/selectors/navbarHeight.js